const MODULE_NAME = 'permission';

export const selectRole = (state) => state[MODULE_NAME].roles;
